import { motion } from "framer-motion";
import { EVENTS } from "@/data/site";

const EASE = [0.22, 1, 0.36, 1];

export default function Events() {
  return (
    <section
      id="events"
      className="relative bg-surface/40 py-24 md:py-32 border-t border-white/10"
      data-testid="events-section"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mb-12"
        >
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-spartanorange" />
            <span className="font-mono text-xs tracking-[0.25em] uppercase text-white/70">
              Events &amp; Exhibitions
            </span>
          </div>
          <h2 className="font-display uppercase tracking-tighter text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            On the floor,
            <span className="text-spartangreen"> in the field</span>
          </h2>
        </motion.div>

        <div className="border-t border-white/10">
          {EVENTS.map((e, i) => (
            <motion.div
              key={e.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, ease: EASE, delay: i * 0.08 }}
              className="group grid grid-cols-1 md:grid-cols-[120px_1fr_auto] gap-3 md:gap-8 items-center py-8 border-b border-white/10 hover:bg-obsidian/60 transition-colors duration-300 px-2 md:px-4"
              data-testid={`event-row-${i}`}
            >
              <span className="font-display text-5xl text-spartanorange leading-none">
                {e.year}
              </span>
              <h3 className="font-sans text-lg md:text-xl text-white group-hover:text-spartanorange transition-colors duration-300 max-w-3xl">
                {e.title}
              </h3>
              <div className="flex flex-col md:items-end font-mono text-xs tracking-wide uppercase text-white/55">
                <span>{e.date}</span>
                <span>{e.location}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
